module.exports = __webpack_public_path__ + "static/how-carebits-works-banner-234c355386f27d6f37cb869fb5ffceda.png";